<template>
  <div>

  <b-row>
    <b-col cols="12" class="mt-4">

      <el-card class="box-card dashboard-card">

        <div slot="header">
          <strong>Verificação de redes sociais</strong>
        </div>

        <p>
        <small class="text-muted">
          <v-icon class="mr-2 text-primary" name="info-circle"/>
          Copie e cole a URL do completa do seu perfil. Ex: https://www.facebook.com/fulano.oliveira/, ou digite apenas o usuário, como por exemplo fulano.oliveira</small>
        </p>


        <el-form :model="social" ref="social" size="small" class="checkout-form dashboard-form pl-1 pr-1">

          <el-row :gutter="20" class="">

            <!--input facebook-->
            <el-col :span="24">
              <el-form-item label="Facebook" prop="facebook">
                <el-input
                  placeholder="Copie e cole a url do seu perfil do Facebook aqui"
                  v-model="social.facebook"
                  class="input-facebook"
                >
                    <template slot="prepend">
                      <v-icon name="brands/facebook"/>
                    </template>
                </el-input>
              </el-form-item>
            </el-col>

            <!--input instagram-->
            <el-col :span="24">
              <el-form-item label="Instagram" prop="instagram">
                <el-input
                  placeholder="Digite o seu usuário do Instagram aqui, ex: @fulano.oliveira"
                  v-model="social.instagram"
                  class="input-instagram"
                > <template slot="prepend"><v-icon name="brands/instagram"/></template></el-input>
              </el-form-item>
            </el-col>

             <el-col :span="24">
                <el-form-item label="Strava" prop="strava">
                   <el-input
                      placeholder="Copie e cole a url do seu perfil do Strava aqui"
                      v-model="social.strava"
                      class="input-strava"
                   > <template slot="prepend">
                      <img :src="StravaIcon" alt="Icone"/>
                   </template></el-input>
                </el-form-item>
             </el-col>

            <el-col :xs="24" class="mt-2">

              <el-button
                @click="submitSocial"
                :loading="loading.save"
                type="blue"
                size="mini"
                class="w-50 text-uppercase font-weight-bold"
              >
                Salvar redes sociais
              </el-button>

            </el-col>
          </el-row>
        </el-form>

      </el-card>
    </b-col>
  </b-row>

  </div>

</template>

<script>

    import UserService from '@/services/user.service';
    import StravaIcon from '@/assets/img/strava.svg';

    export default {
    name: 'SocialForm',
        props: {
            socialData: {
                type: Array,
                default: null
            },
        },
    async mounted() {
       if (!this.userData.data._id) await this.getUser();
       this.user = this.userData.data

    },
    data() {
        return {
            loading: {
                save:  false
            },
            editSocial: false,
            social: {
                facebook: '',
                instagram: '',
                twitter: '',
                strava: '',
            },
           StravaIcon
        }
    },
    methods: {

        //Envio do formulário Informações de Cobrança
        submitSocial() {

          this.loading.save = true;
          const data = this.social;

          UserService.setSocial(data)
              .then(async (response) => {
                  await this.getUser()
                  this.$message({
                      message: response.data.message,
                      type: 'success'
                  });
                  this.loading.save = false;
                  this.editSocial = false;

              })
              .catch(err => {
                  this.$message.error(err.response.data.message);
                  this.loading.save = false;
                  this.editSocial = false;
              });

        },

       //Obtem os dados do usuário.
       async getUser() {
          await this.$store.dispatch('user/get', await UserService.getUserData())
       },
    },
    computed: {
       userData() {
          return this.$store.state.user
       }
    },
     watch: {
            socialData: function (n) {
                if (n) {
                    let f = n.find(o => o.name === 'facebook');
                    this.social.facebook = f.url;

                    let i = n.find(o => o.name === 'instagram');
                    this.social.instagram = i.url;

                    let t = n.find(o => o.name === 'twitter');
                    this.social.twitter = t.url;

                   let s = n.find(o => o.name === 'strava');
                   this.social.strava = s.url;
                }
            },
            'social.facebook': function (n) {
this.social.facebook = n.replace(/^(?:https?:\/\/)?(?:www\.)?(?:facebook)?(?:.com?\/)?(?:\/)?/i, "");
            },
            'social.instagram': function (n) {
                this.social.instagram = n.replace(/^(?:https?:\/\/)?(?:www\.)?(?:instagram)?(?:.com?\/)?(?:\/)?/i, "");
            },
            'social.twitter': function (n) {
                this.social.twitter = n.replace(/^(?:https?:\/\/)?(?:www\.)?(?:twitter)?(?:.com?\/)?(?:\/)?/i, "");
            },
            'social.strava': function (n) {
                this.social.strava = n.replace(/^(?:https?:\/\/)?(?:www\.)?(?:strava)?(?:.com?\/)?(?:\/)?/i, "");
            }
        }
 };
</script>
